import {removeOfferTemplateNote} from "@project/sdk/sales";
import {RemoveOfferTemplateNoteResponse} from "@project/sdk/sales/zod";
import {mutationOptions} from "@tanstack/react-query";
import {offerTemplateKeys, offerTemplateMutationKeys} from "../../../../../offerTemplate-keys";

export function removeOfferTemplateNoteMutationOptions(id: string) {
  return mutationOptions({
    mutationKey: offerTemplateMutationKeys.removeOfferTemplateNote,
    mutationFn: async (noteId: number) =>
      RemoveOfferTemplateNoteResponse.parse(await removeOfferTemplateNote(id, noteId)),
    onSuccess: async (_result, _variables, _context, {client}) => {
      await Promise.all([
        client.invalidateQueries({queryKey: offerTemplateKeys.detail(id)}),
        client.invalidateQueries({queryKey: offerTemplateKeys.lists()}),
      ]);
    },
  });
}
